import React, {  } from "react";
import { Card, Checkbox, Grid, Box, Typography, IconButton, MenuItem } from "@mui/material";
import whiteBackIcon from "../../../icons/whiteBackIcon.svg";
import { useStyles } from "../styles";
import { AppConfigSettingsViewEnum } from "../applicationsConfigSettings";
import { CustomQuestionTypeEnum, ApplicationVehicleDtoTypeEnum } from "@inosio/payments-sdk";
import CustomQuestionFields from "./CustomQuestionFields";
import { InputField } from "../../../components/InputController";
import { applicationStyles } from "../../../resui/applications/components/CustomStyles";
import CustomDropdown from "../../../components/customDropdown";

interface PropsType {
  setView: React.Dispatch<React.SetStateAction<AppConfigSettingsViewEnum>>;
}

export default function ApplicationsVehicles({ setView }: PropsType) {
  const classes = useStyles();
  const classes1 = applicationStyles();

  const getTypography = (text: string, fontWeight: number, fontSize: string, restProps?: object) => (
    <Typography
      sx={{
        fontFamily: 'Work Sans',
        fontWeight: { fontWeight },
        fontSize: { fontSize },
        lineHeight: '22px',
        ...restProps,
      }}
    >
      {text}
    </Typography>
  )

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ display: "flex", flexDirection: "column", color: "#000" }}>
        <Box className={classes.headerContainer} sx={{ backgroundColor: '#BE6531' }}>
          <IconButton
            sx={{ marginRight: "10px", marginTop: "-4px" }}
            onClick={() => setView(AppConfigSettingsViewEnum.Dashboard)}
          >
            <img src={whiteBackIcon} alt="" height="14px" />
          </IconButton>
          {getTypography('Vehicles', 600, '24px', { color: '#fff' })}
        </Box>

        <Grid container sx={{ p: 2, pt: 2, pb: 1, position: 'relative' }}>

          <Box sx={{ width: '100%', p: 2, pb: 4 }}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography sx={{ mb: -2 }} className={classes1.bodyText}>
                  I do not have a vehicle
                  <Checkbox 
                    onChange={() => {}}
                    inputProps={{ 'aria-label': 'controlled' }} 
                    sx={{ ml: 1 }}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} lg={4.5} xl={3.5}>
                <Typography sx={{ mb: 2 }} className={classes1.labelText}>Vehicle details</Typography>
                <CustomDropdown
                  isFullWidth
                  label={"Car / Truck"}
                  value={''}
                  handleChange={() => {}}
                  menuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: '24px',
                      },
                    },
                  }}
                >
                  <MenuItem style={{ height: "36px" }} value=''>
                    Select one
                  </MenuItem>
                  {Object.values(ApplicationVehicleDtoTypeEnum).map((value, index) => (
                    <MenuItem style={{ height: "36px" }} value={value} key={index}>
                      {value}
                    </MenuItem>
                  ))}
                </CustomDropdown>
                <InputField
                  name={"Make"}
                  label={"Make"}
                  value={''}
                />
                <InputField
                  name={"Model"}
                  label={"Model"}
                  value={''}
                />
                <InputField
                  name={"Year"}
                  label={"Year"}
                  value={''}
                />
                <InputField
                  name={"Color"}
                  label={"Color"}
                  value={''}
                />
                <InputField
                  name={"LicensePlate"}
                  label={"License Plate"}
                  value={''}
                />
                <InputField
                  name={"Length"}
                  label={"Length"}
                  value={''}
                />
              </Grid>
              <Grid item xs={12} sm={2} lg={3.5} xl={4.5}>
              </Grid>
              <Grid item xs={12} sm={2} lg={2} xl={2}>
                {/* <Typography sx={{ mt: 8 }} className={classes1.bodyText}>
                  when != car/truck then NO license plate but ADD length.
                </Typography> */}
              </Grid>
            </Grid>
          </Box>

          <CustomQuestionFields CustomQuestionType={CustomQuestionTypeEnum.VehicleV1} />
        </Grid>
      </Card>
    </Grid>
  );
}
